export enum eAuditStatus {
  /**
   * 开启
   */
  OPEN = 1,
  /**
   * 关闭
   */
  CLOSE = 0,
}
export enum eUpdateType {
  /**
   * 可选更新
   */
  SELECTUPDATE = 1,
  /**
   * 强制更新
   */
  SELECT = 2,
}
export enum eUpdateVersion {
  /**
   * 可选更新
   */
  PC = 1,
  /**
   * 强制更新
   */
  ANDRIOD = 2,
  /**
   * IOS
   */
  IOS = 5,
  /**
   * 无
   */
  NO = 0,
}

export interface iVersion {
  id: number;
  /* 端 1-pc 2-andriod */
  scope: eUpdateVersion;
  /* 版本号 */
  version: string;
  /* 更新日志 */
  change_log: string[];
  /* 1-可选更新，2-强制更新 */
  update_type: eUpdateType;
  /* 是否是当前版本 */
  current: boolean;
  created_at: string;
  audit_status?: eAuditStatus;
}

export interface iVersionSearch {
  /* 端 1-pc 2-andriod */
  scope: eUpdateVersion;
  search_key: string;
}
